import { Component } from '@angular/core';
import { AuthService } from '../../../../../app-core/src/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  // Show dev login when running on localhost
  showDevLogin = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  devEmail = 'pragadeesh.waran@anyo.app';
  devPassword = '';
  isLoading = false;

  constructor(public authService: AuthService) { }

  async devLogin() {
    if (!this.devEmail || !this.devPassword) {
      return;
    }
    this.isLoading = true;
    try {
      await this.authService.devAdminAuth(this.devEmail, this.devPassword);
    } catch (error) {
      // Error is already handled in auth service
    } finally {
      this.isLoading = false;
    }
  }
}
